import { render } from "./PagePagination.vue?vue&type=template&id=6934af34"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__